/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import basicInfoIcon from '../assets/img/info.png';
import incomeInfoIcon from '../assets/img/cash.png';
import 'react-datepicker/dist/react-datepicker.css';
import useShopifyApi from '../hooks/useShopifyApi';
import { addNewUserDetails, addAaronsReferral } from '../redux/actions';
import useListenSize from '../hooks/useListenSize';
import ErrorHandling from '../components/ErrorHandling/index';
import SubmitButton from '../components/SubmitButton';
import NewUserBackButton from '../components/NewUserBackButton';
import formatNewUserPayload from '../helpers/formatNewUserPayload';

function NewUserReview() {
  const { request, response, loading, error } = useShopifyApi();
  const { handleSubmit } = useForm();

  const store = useSelector(state => ({
    newUserDetails: state.personal?.newUserDetails,
    phone: state.contact?.phone,
    checkoutLookupData: state.personal?.checkoutLookupData,
    sessionId: state.technical?.shopifySessionId,
    orgId: state.technical?.shopifyOrgId,
    featureGates: state.technical?.featureGates,
  }));

  const maskedSsn = store.newUserDetails?.ssn?.replace(/^.{6}/, 'Xxx-xx');
  const newUserPayload = store.newUserDetails;
  newUserPayload.phone = store.phone;
  const formattedPayload = formatNewUserPayload(newUserPayload);
  const history = useHistory();
  const dispatch = useDispatch();
  useListenSize();

  useEffect(() => {
    window.threatmetrix?.profile('tmx.katapult.com', store?.orgId, store?.sessionId, 2004);
    console.log('loaded 2004');
  }, []);

  const onSubmit = async () => {
    await request.applicationRequest({ ...newUserPayload, ...formattedPayload });
    const data = await response.json();
    const newUserAppUid = data.uid;

    if (response.ok) {
      if (store.featureGates?.UseThreatMetrix) {
        await request.preapproveTmRequest(newUserAppUid, store.sessionId);
      } else {
        await request.preapproveRequest(newUserAppUid);
      }
      const preapproveData = await response.json();
      if (preapproveData.approved) {
        dispatch(addNewUserDetails({ available_limit: preapproveData.approval_limit }));
        history.push('/new-user-approved');
      } else {
        // A decline off preapproveRequest is the one path that can carry an
        // Aaron's referral (spec/aarons-decline-flow/SPEC.md §4.1). An absent
        // `aarons` key is already the "no referral" answer for NotApproved.
        dispatch(addAaronsReferral(preapproveData.aarons));
        history.push('/not-approved');
      }
    } else {
      // response.ok === false has no body to read a referral from — never
      // dispatch addAaronsReferral on this branch.
      history.push('/not-approved');
    }
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <section className="k-form k-form-indent">
          <div className="k-review-top-bar">
            <img className="k-review-top-bar-icon" src={basicInfoIcon} alt="" />
            <div>Basic Information</div>
          </div>
          <table className="k-review-table">
            <tbody>
              <tr>
                <td className="k-review-table-left">Name</td>
                <td className="k-review-table-right">
                  {store.newUserDetails.billing_first_name} {store.newUserDetails.billing_last_name}
                </td>
              </tr>
              <tr>
                <td className="k-review-table-left">Date of birth</td>
                <td className="k-review-table-right">{store.newUserDetails.dob_day}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">SSN/ITIN</td>
                <td className="k-review-table-right">{maskedSsn}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">Email</td>
                <td className="k-review-table-right">{store.newUserDetails.email}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">Address</td>
                <td className="k-review-table-right">
                  {store.newUserDetails.billing_address} {store.newUserDetails.billing_address2},
                  <br />
                  {store.newUserDetails.billing_city}, {store.newUserDetails.billing_state}{' '}
                  {store.newUserDetails.billing_zip}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="k-form k-form-indent">
          <div className="k-review-top-bar">
            <img className="k-review-top-bar-icon" src={incomeInfoIcon} alt="" />
            <div>Income Information</div>
          </div>
          <table className="k-review-table">
            <tbody>
              <tr>
                <td className="k-review-table-left">
                  {store.newUserDetails.per_period === 'year' ? 'Yearly' : 'Per paycheck'} income
                </td>
                <td className="k-review-table-right">${parseInt(store.newUserDetails.income, 10)?.toFixed(2)}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">Pay frequency</td>
                <td className="k-review-table-right">{store.newUserDetails.payment_frequency}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">Last pay day</td>
                <td className="k-review-table-right">{store.newUserDetails.last_pay_date}</td>
              </tr>
              <tr>
                <td className="k-review-table-left">Direct deposit</td>
                <td className="k-review-table-right">{store.newUserDetails.direct_deposit}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="k-form k-form-indent">
          <SubmitButton loading={loading} />
          <NewUserBackButton />
        </section>
      </form>
    </div>
  );
}

export default NewUserReview;
